var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsRevenue01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n\n      .cls-1 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ads revenue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,6.38V.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17,7.35c0-.91,0-1.81,0-2.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7,7.33c0-.91,0-1.81,0-2.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.64,15.75A7.64,7.64,0,1,1,12,8.08,7.61,7.61,0,0,1,19.64,15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.17,19.64a2.88,2.88,0,0,1-1.88-.6,2.56,2.56,0,0,1-.9-1.6l.94-.23A1.73,1.73,0,0,0,11,18.37a1.94,1.94,0,0,0,1.24.4,1.74,1.74,0,0,0,.77-.16,1.28,1.28,0,0,0,.53-.47,1.14,1.14,0,0,0,.2-.68,1,1,0,0,0-.22-.67,2.11,2.11,0,0,0-.6-.46,9.19,9.19,0,0,0-.91-.39,8.26,8.26,0,0,1-1.11-.52,2.21,2.21,0,0,1-.73-.69,1.69,1.69,0,0,1-.27-1,1.85,1.85,0,0,1,.29-1A1.91,1.91,0,0,1,11,12a2.64,2.64,0,0,1,1.19-.26,2.46,2.46,0,0,1,1.28.33,2.33,2.33,0,0,1,.89,1l-.76.48a2,2,0,0,0-.61-.69,1.64,1.64,0,0,0-1.5-.09,1.07,1.07,0,0,0-.45.39,1,1,0,0,0-.16.58.94.94,0,0,0,.19.6,1.64,1.64,0,0,0,.57.43c.25.12.55.25.9.38a6.86,6.86,0,0,1,1.15.55,2.27,2.27,0,0,1,.74.7,1.82,1.82,0,0,1,.27,1,2.07,2.07,0,0,1-.31,1.14,2.34,2.34,0,0,1-.88.8A2.79,2.79,0,0,1,12.17,19.64Zm-.42-7.74V10.68h.65V11.9Zm0,8.84V19.52h.65v1.22Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsRevenue01);
export default __webpack_public_path__ + "static/media/ads_revenue_01.727c42850280a4481a9a8ad28c381e12.svg";
export { ForwardRef as ReactComponent };